var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.03052 4.93195C7.73771 4.63896 7.26284 4.63882 6.96985 4.93162C6.96973 4.93174 6.96962 4.93186 6.9695 4.93195L6.00001 5.90196L5.03052 4.93195C4.73752 4.63896 4.26249 4.63896 3.96952 4.93195C3.67655 5.22494 3.67653 5.69997 3.96952 5.99294L4.93951 6.96246L3.9695 7.93195C3.67651 8.22494 3.67651 8.69997 3.9695 8.99294C4.26249 9.28593 4.73752 9.28593 5.03049 8.99294L6.00001 8.02296L6.9695 8.99297C7.26249 9.28596 7.73752 9.28596 8.03049 8.99297C8.32348 8.69997 8.32348 8.22494 8.03049 7.93197L7.06051 6.96246L8.03052 5.99297C8.32351 5.70016 8.32365 5.22529 8.03084 4.9323C8.03073 4.93218 8.03063 4.93207 8.03052 4.93195Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 0.962463C2.68629 0.962463 0 3.64875 0 6.96246C0 10.2762 2.68629 12.9625 6 12.9625C9.31371 12.9625 12 10.2762 12 6.96246C11.9964 3.65023 9.31223 0.966049 6 0.962463ZM6 11.4625C3.51471 11.4625 1.5 9.44775 1.5 6.96246C1.5 4.47717 3.51471 2.46246 6 2.46246C8.48529 2.46246 10.5 4.47717 10.5 6.96246C10.4972 9.4466 8.48414 11.4597 6 11.4625Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.962463)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRounded);
export default __webpack_public_path__ + "static/media/cross-rounded.61c2731afacd93daee4f77a482106bbe.svg";
export { ForwardRef as ReactComponent };